import './tree-view.scss';
import React, { Component } from 'react';
import TreeView from './tree-view';
import TreeContext from './../tree-context/view/tree-context';
import SearchBoxContainer from './../search-box/view/search-box-container';

export default class TreeViewBox extends Component {
  constructor() {
    super();
    this.state = {
      contextMenuOpen: false,
      contextNode: null,
      contextPos: null,
      isLoading: false
    };
  }

  componentDidMount() {
    document.addEventListener('click', (event) => {
      this.contextClosed();
    });
  }

  contextOpened(node, e) {
    this.setState({
      contextMenuOpen: true,
      contextNode: node,
      contextPos: e
    });
  }

  contextClosed() {
    if (this.state.contextMenuOpen) {
      this.setState({
        contextMenuOpen: false
      });
    }
  }

  isLoadingChanged(isLoading) {
    this.setState({isLoading});
  }

  _renderContextMenu() {
    if (this.state.contextMenuOpen)
      return <TreeContext node={this.state.contextNode}
                          closeContextMenu={this.contextClosed.bind(this)}
                          position={this.state.contextPos}
                          collapseNode={this._collapseNode.bind(this)}
                          expandNode={this._expandNode.bind(this)}
                          changeTreeNode={this._loadTreeNode.bind(this)} />;
    else
      return false;
  }

  _renderLoadingIcon() {
    if (this.state.isLoading) {
      return (<div id='treeLoading'>
        <i className='fa fa-3x fa-spinner fa-pulse'></i>
      </div>);
    }

    return false;
  }

  _loadTreeNode(node) {
    this.props.nodeChanged(node.idPlant);
  }

  _collapseNode(node) {
    this.refs.treeViewComponent.collapseNode(node);
  }

  _expandNode(node) {
    this.refs.treeViewComponent.expandNode(node);
  }

  _onBlur() {
    this.contextClosed();
  }

  _onKeyDown(e) {
    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        break;
      case 'ArrowRight':
        e.preventDefault();
        break;
    }
  }

  render() {
    return (
      <div id='treeViewContainer' onContextMenu={e => { e.preventDefault();}}>
        <div id='AssetTreeHeader'>
          {this.props.children}
        </div>
        <div className='searchBox'>
          <SearchBoxContainer />
        </div>
        <div className='treeView' onKeyDown={this._onKeyDown} >
            <TreeView ref='treeViewComponent' className='treeView'
                      contextOpened={this.contextOpened.bind(this)}
                      contextClosed={this.contextClosed.bind(this)}
                      isLoadingChanged={this.isLoadingChanged.bind(this)}
                      collapseNode={this._collapseNode.bind(this)}
              {...this.props}/>
        </div>
        {this._renderContextMenu()}
        {this._renderLoadingIcon()}
      </div>);
  }
}

TreeViewBox.propTypes = {
  idPlant: React.PropTypes.number.isRequired,
  selectionChanged: React.PropTypes.func.isRequired,
  nodeChanged: React.PropTypes.func.isRequired,
};



/** WEBPACK FOOTER **
 ** app/components/tree-view/tree-view-box.js
 **/